/* rb-market-links.js — keeps visitors in their own market when they follow a store link.
   Shopify picks the market from the URL prefix (/en-be/, /en-gb/, /en/ …). Links typed into content or translations
   as "/en/pages/…" or "/pages/…" send a Belgian visitor to the Finnish store, and Shopify then moves the whole cart to
   Finnish prices and pre-selects Finland at checkout. Liquid fixes the links it renders (snippets/rb-market-url.liquid);
   this is the safety net for the rest (product descriptions, rich text, app widgets, AJAX-rendered drawers).
   It rewrites same-shop links to pages, products, collections, blogs, policies, search and cart onto the visitor's
   own prefix; it does nothing on the default Finnish storefront (root "/"), where unprefixed links are already right. */
(function () {
  if (window.__rbMarketLinks) return;
  window.__rbMarketLinks = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (root === '/') return;
  var base = root.replace(/\/$/, '');
  var LOCALE = /^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i;
  var DIRS = /^\/(pages|products|collections|blogs|policies|search|cart)(\/|$)/i;

  function fix(a) {
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#' || /^(mailto|tel|sms|javascript):/i.test(href)) return;
    var u;
    try { u = new URL(href, location.href); } catch (e) { return; }
    if (u.host !== location.host) return;
    var path = u.pathname;
    if (path === base || path.indexOf(root) === 0) return;
    var bare = path.replace(LOCALE, '');
    if (!DIRS.test(bare)) return;
    a.setAttribute('href', base + bare + u.search + u.hash);
  }

  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.tagName === 'A') fix(node);
    var links = node.querySelectorAll ? node.querySelectorAll('a[href]') : [];
    for (var i = 0; i < links.length; i++) fix(links[i]);
  }

  function start() {
    scan(document.body);
    if (window.MutationObserver) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var added = records[i].addedNodes;
          for (var j = 0; j < added.length; j++) scan(added[j]);
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    /* Last guard: a link changed after the scan still gets fixed on the way out. */
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (a) fix(a);
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
